module.exports = __webpack_public_path__ + "img/1499117810.20754143.jpg";